import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  currentLanguage: null,
  language: [],
};

const language = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default language;
